import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { client, withToken, readItem } from '../lib/directus';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function PostPage() {
  const query = useQuery();
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchArticle() {
      const token = query.get('token');
      const isPreview = query.get('preview');
      const version = query.get('version');

      const getPost = () => readItem('posts', id, version ? { version } : {});

      let result;
      try {
        if (isPreview && token) {
          result = await client.request(withToken(token, getPost()));
        } else {
          result = await client.request(getPost());
        }
      } catch (error) {
        console.error('Error fetching article:', error);
        result = {
          title: 'Post not found',
          content: "We couldn't find this post.",
        };
      }

      setArticle(result);
      setLoading(false);
    }

    fetchArticle();
  }, [id, query]);

  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-950 flex items-center justify-center">
        <p className="text-neutral-400">Loading...</p>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="min-h-screen bg-neutral-950 flex items-center justify-center">
        <p className="text-neutral-400">Post not found.</p>
      </div>
    );
  }

  const isPreview = query.get('preview');

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-200">
      <div className="max-w-3xl mx-auto px-5 py-10">
        <Link to="/posts" className="text-primary-400 hover:text-primary-300 text-sm mb-6 inline-block">
          &larr; Back to posts
        </Link>

        {isPreview && (
          <div className="bg-primary-400/10 border border-primary-400/25 text-primary-400 px-4 py-2 rounded-lg text-sm font-medium mb-6">
            Preview Mode
          </div>
        )}

        <h1 className="text-3xl font-bold text-neutral-50 mb-6">{article.title}</h1>

        <div className="prose prose-invert max-w-none text-neutral-300 leading-relaxed whitespace-pre-wrap">
          {article.content}
        </div>
      </div>
    </div>
  );
}
